import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TripReplayCabRoutingModule } from './trip-replay-cab-routing.module';
import { TripReplayCabComponent } from './components/trip-replay-cab/trip-replay-cab.component';
import { LoaderModule } from 'mis-crystal-design-system/loader';
import { TripReplayModule } from '../trip-replay/trip-replay.module';
import { MapViewCabComponent } from './components/map-view-cab/map-view-cab.component';



@NgModule({
  declarations: [
    TripReplayCabComponent,
    MapViewCabComponent,
  ],
  imports: [
    CommonModule,
    LoaderModule,
    TripReplayCabRoutingModule,
    TripReplayModule
    // SharedModule,
  ]
})
export class TripReplayCabModule { }
